import { x } from '@/style';

import {
  Form,
  Input,
  RadioButtonGroup,
  Select,
} from '@ui-furniture/common/form';
import { AddressTypeahead } from '@ui-furniture/common/form/address/typeahead';
import { Label, LabelText } from '@ui-furniture/common/form/common';
import { Button, Card, Row, RowItem, VStack } from '@ui-furniture/elements';
import { ChildAnimation } from '@ui-furniture/ui/animation/child';
import { LoadingButton } from '@ui-furniture/ui/loading/button';
import { Popover } from '@ui-furniture/ui/popovers/popover';

import { createRecommendationOptions as options } from '../common/create-recommendation-schema';
import { useSurveyRecommendation } from '../context/survey-recommendation';
import { useAdditionalDetailsSummary } from '../hooks/use-additional-details-summary';

export const RecommendationForm = () => {
  const {
    formId,
    firstInputId,
    isCalculating,
    form,
    calculatePriceAndRecommendation,
  } = useSurveyRecommendation();
  const additionalDetailsSummary = useAdditionalDetailsSummary(
    form.control as any
  );

  return (
    <x.div id={formId}>
      <Form
        form={form}
        onSubmit={form.handleSubmit(calculatePriceAndRecommendation)}
        py='md'
        minW='100%'
      >
        <VStack w='100%' gap='xl'>
          <ChildAnimation>
            <VStack>
              <Card px='xl' py='xl'>
                <VStack gap='lg'>
                  <Row>
                    <RowItem>
                      <Input
                        id={firstInputId}
                        name='price'
                        label='Property Price'
                        format='currency'
                        placeholder='e.g. £282,000'
                        allowNegative={false}
                      />
                    </RowItem>
                    <RowItem>
                      <RadioButtonGroup
                        name='ageRange'
                        label='Property Age (Years)'
                        options={options.ageRange}
                        informationTooltip='A guess is fine'
                      />
                    </RowItem>
                    <RowItem>
                      <Select
                        name='propertyType'
                        label='Property Type'
                        placeholder='e.g. Flat'
                        options={options.propertyType}
                      />
                    </RowItem>
                  </Row>
                  <Row>
                    <RowItem flex='1'>
                      <AddressTypeahead
                        label='Address'
                        name='address'
                        placeholder={`What's the address of the property`}
                      />
                    </RowItem>
                    <RowItem flex='unset'>
                      <Input
                        label='No of Bedrooms'
                        name='bedroomCount'
                        placeholder='3'
                        type='number'
                      />
                    </RowItem>
                  </Row>
                  <Row>
                    <RowItem>
                      <Label as='div'>
                        <LabelText isOptional={false}>
                          Additional Details
                        </LabelText>
                        <Popover
                          buttonProps={'input'}
                          closeOnSelect={false}
                          buttonContent={additionalDetailsSummary}
                          popoverContent={({ close }) => (
                            <VStack p='xl' w='600px' maxW='100%'>
                              <Row>
                                <RowItem>
                                  <RadioButtonGroup
                                    name='condition'
                                    label='Condition'
                                    options={options.condition}
                                  />
                                </RowItem>
                              </Row>
                              <Row>
                                <RowItem>
                                  <RadioButtonGroup
                                    name='defects'
                                    label='Defects'
                                    options={options.defects}
                                  />
                                </RowItem>
                              </Row>
                              <Row>
                                <RowItem>
                                  <RadioButtonGroup
                                    name='renovationPlans'
                                    label='Renovation Plans'
                                    options={options.renovationPlans}
                                  />
                                </RowItem>
                              </Row>
                              <Row>
                                <RowItem>
                                  <Select
                                    name='specialistConstruction'
                                    label='Specialist Construction'
                                    isMulti
                                    placeholder='Add if applicable'
                                    menuPlacement='top'
                                    closeMenuOnSelect={false}
                                    options={options.specialistConstruction}
                                  />
                                </RowItem>
                              </Row>
                              <Button type='button' onClick={close}>
                                Done
                              </Button>
                            </VStack>
                          )}
                        />
                      </Label>
                    </RowItem>
                  </Row>

                  <LoadingButton
                    isLoading={isCalculating}
                    type='submit'
                    alignSelf={{ _: 'center', tablet: 'end' }}
                  >
                    Submit
                  </LoadingButton>
                </VStack>
              </Card>
            </VStack>
          </ChildAnimation>
        </VStack>
      </Form>
    </x.div>
  );
};
